// ZT Health brand mark (rebrand — Feb 2026)
// Uses the official horizontal combination mark WITH tagline from brand guidelines.
// Locally served high-resolution PNG (2000x646) for crisp rendering at all sizes.
// - light=false → full-color logo on light backgrounds (default)
// - light=true  → white version for use on navy footer / dark backgrounds

const HORIZONTAL_WITH_TAG = "/zt-health-logo.png?v=notag";

export default function Logo({ light = false, className = "" }) {
  return (
    <img
      src={HORIZONTAL_WITH_TAG}
      alt="ZT Health — Better Health. Stronger Communities."
      data-testid="zt-logo"
      width={2000}
      height={646}
      className={`h-[75px] md:h-[85px] w-auto select-none ${light ? "brightness-0 invert" : ""} ${className}`}
      style={{ imageRendering: "auto" }}
      draggable="false"
    />
  );
}
